import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ScontractOrdersType } from '@cl/shared/models/scontracts/scontract-orders-type.model';
import { HttpClient } from '@angular/common/http';
import { CommandResult, OrdersType } from '@cl/shared/models';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ScontractOrdersTypesService extends BaseService<ScontractOrdersType> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/scontract-orders-types/');
    }

    async getScontractOrderTypes(scontractId: number): Promise<CommandResult<OrdersType[]>> {
        return await lastValueFrom(this.httpClient.get<CommandResult<OrdersType[]>>(`${this.baseApiUrl}for-scontract/${scontractId}`));
    }
}
